import { useEffect, useState } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { ArrowLeft, UserRound } from 'lucide-react'
import { Button, Card } from '@/components/ui'
import { useStudioStore } from '@/store'
import { PartnerTeacherAnalyticsCards } from '@/components/pedagogy/PartnerTeacherAnalyticsCards'
import { useStudioPeriods } from '@/hooks/useStudioPeriods'
import { listPedagogyTeacherAnalytics } from '@/services/pedagogyTeacherAnalyticsService'
import { isTeacherAppEnabledForPartner } from '@/lib/teacherAppFeature'

export function PartnerTeacherAnalyticsDetailPage() {
  const { partnerNumber = '', studioId = '', teacherId = '' } = useParams<{ partnerNumber: string; studioId: string; teacherId: string }>()
  const navigate = useNavigate()
  const parsedStudioId = Number(studioId)
  const studio = useStudioStore(state => state.studios.find(item => item.studio_internal_id === parsedStudioId))
  const hasFullPedagogyAnalyticsAccess = studio?.role === 'owner'
    || studio?.role === 'manager'
    || studio?.role === 'senior_teacher'
    || studio?.role === 'management_company'
    || studio?.access_kind === 'owner'
    || studio?.access_kind === 'senior_teacher'
    || studio?.access_kind === 'management_company'
  const analyticsEnabled = isTeacherAppEnabledForPartner(Number(partnerNumber)) || hasFullPedagogyAnalyticsAccess
  const isSeniorTeacher = studio?.role === 'senior_teacher' || studio?.access_kind === 'senior_teacher'
  const { currentPeriod } = useStudioPeriods(parsedStudioId)
  const [teacherName, setTeacherName] = useState('')

  useEffect(() => {
    if (!studio || !currentPeriod) return
    let cancelled = false
    void listPedagogyTeacherAnalytics({ periodId: currentPeriod.period_id, partnerNumber: Number(partnerNumber), cityId: studio.city_id, teacherId: teacherId || null })
      .then(rows => { if (!cancelled) setTeacherName(rows[0]?.fullName || '') })
      .catch(() => { if (!cancelled) setTeacherName('') })
    return () => { cancelled = true }
  }, [currentPeriod, partnerNumber, studio, teacherId])

  if (!analyticsEnabled) {
    return <Navigate to={`/partners/${partnerNumber}/studios/${studioId}/teachers`} replace />
  }

  if (!studio || !Number.isFinite(Number(partnerNumber))) {
    return <Card className="text-sm text-muted-foreground">Не удалось определить педагога.</Card>
  }

  return <div className="space-y-5 pb-24">
    {teacherId && <Button variant="outline" className="inline-flex h-9 w-auto shrink-0 items-center gap-2 whitespace-nowrap px-3 text-sm" onClick={() => navigate(`/partners/${partnerNumber}/studios/${studioId}/teachers?view=analytics`)}>
      <ArrowLeft size={16} /> К аналитике педагогов
    </Button>}
    <div>
      <div className="flex flex-wrap items-center gap-2 text-sm font-medium text-muted-foreground"><UserRound size={16} className="text-primary" />{teacherName || 'Педагог'}{isSeniorTeacher && <span className="inline-flex rounded-full bg-primary/10 px-2 py-0.5 text-xs font-medium text-primary">Старший педагог</span>}</div>
      <h1 className="mt-1 text-xl font-bold tracking-tight">Аналитика педагога</h1>
    </div>
    <PartnerTeacherAnalyticsCards
      teacherId={teacherId}
      partnerNumber={Number(partnerNumber)}
      cityId={studio.city_id}
      studioId={parsedStudioId}
      title={teacherId ? 'Показатели педагога' : 'Моя аналитика'}
      showTitle={false}
    />
  </div>
}
